<template>
  <div class="is-block">
    <input id="showMeasures" type="checkbox" name="showMeasures" class="switch is-rounded is-rtl" v-model="showing">
    <label for="showMeasures">{{$t("simulator.showMeasures")}}</label>
  </div>
</template>
<script>
export default {
  name: 'ShowMeasures',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showing: false,
    }
  },
  created() {
    this.showing = this.selected;
  },
  watch: {
    selected() {
      this.showing = this.selected;
    },
    showing() {
      if(this.selected !== this.showing) {
        this.$emit('showing', this.showing);
      }
    }
  }
}
</script>